module.exports = __webpack_public_path__ + "cd455783/img/chevron-down-icon.5542f65c.svg";